import { render, staticRenderFns } from "./situationStatistics.vue?vue&type=template&id=00c6d354&scoped=true&"
import script from "./situationStatistics.vue?vue&type=script&lang=js&"
export * from "./situationStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c6d354",
  null
  
)

export default component.exports